import React from 'react';
import Checkbox from 'rc-checkbox';
import { InputItem, Icon } from 'antd-mobile';
import Remark from './remark';

const isMobile = /Android|iPhone|iPod|iPad/i.test(navigator.userAgent);
const isIOS =/iphone|iPhone|ipad|ipod|ios/i.test(navigator.userAgent);
const isPC = !isMobile;

class CheckboxGroup extends React.Component{
    constructor(props){
        super(props);
        // console.log(props.opts)
        // this.options = props.options.filter(option=>{
        //     return !option.not_usable;
        // });
        this.state = {
            isShow: false,
            serchKey: ''
        };
    }
    onChange = (index)=>{
        let options = this.options;
        let item = options[index]; //copy
        item.checked = !item.checked;

        this.props.onChange && this.props.onChange(this.getCheckedValue());
    }
    getCheckedValue(){
        let arr = [];
        this.options.forEach((item)=>{
            if (item.checked){
                arr.push(item.value);
            }
        });
        return arr;
    }
    hideSelect = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        if(e.target&&e.target.className.indexOf('form-select-wrapper_Mobile') > -1) {
            this.setState({isShow: false})
        }
    }
    showSelect = (flag) => {
        this.setState({
            serchKey: '',
        })
        if(flag){
            return
        }else{
            this.setState({isShow: !this.state.isShow})
        }
    }
    onItemInput(e) {
        let me = this;    //借助闭包
        if(this.timer){
            clearTimeout(this.timer) 
        }
        this.timer = setTimeout(() => {
            me.setState({
                serchKey: e
            })
        }, 500) // 简化写法
    }
    onFocus(e) {
        if(isIOS) {
            setTimeout(() => {
                window.scrollTo({ 
                    top: document.getElementsByClassName('App')[0].offsetHeight - window.innerHeight, 
                    behavior: "smooth" 
                });
                document.getElementsByClassName('form-select-ul')[0].style['height'] = '253px'  
            },300)
            
        }
    }
    onBlur(e) {
        if(isIOS) {
            document.getElementsByClassName('App')[0].style.transform = 'none'
            window.scrollTo(0,this.scrollTopValue)
            document.getElementsByClassName('form-select-ul')[0].style['height'] = 'auto'
        }
    }
    formatOptions(options) {
        let serchKey = this.state.serchKey
        return options.map((item) => {
            if(item.label.indexOf(serchKey) > -1) {
                item.isShowItem  = true
            }else{
                item.isShowItem  = false
            }
            return item
        })
    }

    componentDidUpdate(cur,old) {
        //移动端有单选样式时禁止后面的滚动条
        if(old.isShow !== this.state.isShow && isMobile) {
            if(this.state.isShow) {
                if(isIOS) {
                    this.scrollTopValue = document.documentElement.scrollTop || window.pageYOfset || document.body.scrollTop
                }
                document.documentElement.style.overflow = "hidden";
            }else{
                if(isIOS) {
                    window.scrollTo(0,this.scrollTopValue)
                }
                document.documentElement.style.overflow = "scroll";
            }
        }
    }

    hideSelectFromMask = (e) => {
        this.setState({isShow: false})
    }

    render(){
        let props = this.props;
        let value = props.value || [];
        let { form, is_readonly, api_name, isFirstShow, is_tiled } = props;
        let isTiled = is_tiled === undefined ? true : is_tiled;
        this.options = props.opts || [];
        let options = JSON.parse(JSON.stringify(this.options));
        options && (options = this.formatOptions(options))
        const { getFieldError } = form;
        let errorText = getFieldError(api_name);
        let other_item = options.find((item) => {
            return item.value === 'other';
        });
        if(isFirstShow) {
            options && options.forEach((item)=>{
                item.checked = value.indexOf(item.value) > -1; // 字符串
            });
            this.options = options
        }
        let tiledChecked = options.filter(v => v.checked)
        let otherValue = tiledChecked.find(v => v.value === 'other')
        let optionItems = options.map((option,i)=>{
            let flag = false
            if(option.checked) {
                flag = true
            }
            return (
            option.isShowItem && <li key={option.value} value={option.value} className="form-select-li" >
                {(option.checked ?
                    <Icon type='check' className="select-item-icon" /> : '')}
                    <span onClick={(e) => {this.onChange(i)}}>{option.label}</span>
                    {/* {option.value === 'other' ? otherValue && !is_readonly
                        ? <Remark {...other_item} api_name={api_name + '__o'} form={form} />
                        : (<div className="remark-wrap">
                            <InputItem disabled placeholder={$st('请输入多选备注')} />
                            </div>)
                        : ''} */}

            </li>
            )
        });
        let tempProps = {
            type: 'text',
            placeholder: $st('请输入'),
            className: 'select-ul-search'
        }

        return (
            <div className={isTiled ? "checkbox-group" : "checkbox-group checkbox-group-tiled"} style={{"position": "relative"}}>
            {
                this.state.isShow && isPC && 
                <div onClick={(e) => this.hideSelectFromMask(e)} className="form-select-box-mask"></div>
            }
                {isTiled && options.map((item, index) => (
                    <div key={item.value} className="checkbox-group-item">
                        <label>
                            <Checkbox disabled={is_readonly} checked={item.checked} onChange={() => this.onChange(index)} /> {item.label}
                        </label>
                        {item.value === 'other' && (
                            other_item.checked && !is_readonly
                            ? <Remark {...other_item} api_name={api_name + '__o'} form={form} />
                            : (<div className="remark-wrap">
                                <InputItem disabled placeholder={$st('请输入多选备注')} />
                              </div>)
                            )
                        }
                    </div>
                ))}
                {errorText && isTiled && <div className="input-error">{errorText}</div>}
                {!isTiled && <div>
                    <div className="form-select-wrap">
                    <div className="select-wrap" onClick={() => {this.showSelect(is_readonly)}}>
                        {<div className={is_readonly ? 'form-select form-select-readonly' : 'form-select'}>
                            {<p className='form-select-p'>
                                {
                                    tiledChecked.length ? tiledChecked.map((item, index) => {
                                        return index != 0 ? ';' + item.label : item.label
                                    }) : <span style={{'color':'#999'}}>{$st("请选择")}</span>
                                }
                            </p>}
                        </div>}
                        
                        {/* <Icon type='down' className="select-icon" /> */}
                    </div>
                    {otherValue && (!is_readonly && <Remark {...other_item} api_name={api_name + '__o'} form={form} /> || <div className="remark-wrap">
                        <InputItem disabled placeholder={$st('请输入多选备注')} />
                    </div>)}
                    {errorText && <div className="input-error">{errorText}</div>}
                </div>
                {
                    this.state.isShow && 
                    // 单选到底的时候加个底距离
                    <div className="form-select-box"> 
                        <div className={isPC ? "form-select-wrapper form-select-wrapper_PC" : "form-select-wrapper form-select-wrapper_Mobile"} onClick={(e) => this.hideSelect(e)}>
                            <ul className="form-select-ul">
                            <InputItem {...tempProps} data-type="search" onChange={this.onItemInput.bind(this)} onBlur={this.onBlur.bind(this)} onFocus={this.onFocus.bind(this)}></InputItem>
                                {/* {<li onClick={(e) => {this.selectItem($st('请选择'),'',e)}} className="form-select-li">{(!options.length)&& <Icon type='check' className="select-item-icon" />}{$st("请选择")}</li>} */}
                                {optionItems}
                            </ul>
                        </div>
                    </div>
                }
                </div>
                }
           </div>
        )
    }
}
export default CheckboxGroup;


// WEBPACK FOOTER //
// ./src/component/CheckboxGroup/CheckboxGroup.js